export default {
  cardSelection: {
    title: 'Cards',
    cardTitle: {
      varoDebit: 'Varo Debit Card',
      varoBelieve: 'Varo Believe Card',
    },
    tag: {
      createPin: 'Create PIN',
      locked: 'Locked',
      frozen: 'Frozen',
      processing: 'Processing',
      expired: 'Expired',
      suspended: 'Suspended',
    },
    error: {
      noCards: 'No Cards Available',
    },
    buttons: {
      done: 'Done',
    },
    productOffer: {
      title: 'Get a new debit card',
      message: 'Chat with us to get a new debit card.',
      buttonText: 'Order a new card',
    },
  },
  manageCard: {
    cardTitle: {
      varoDebit: 'Varo Debit Card',
      varoBelieve: 'Varo Believe Card',
    },
    reportLostStolen: 'Report lost or stolen card',
    lockCard: {
      beforeLock: 'Lock your card',
      afterLock: 'Card locked',
      info: 'Lock your card to block new in-store, online, and in-app transactions. Your recurring transfers, direct deposits, and bill payments will continue as usual.',
    },
    freezeCard: {
      beforeFreeze: 'Freeze card',
      afterFreeze: 'Card frozen',
      info: 'Freezing your card blocks new purchases and refunds but won’t affect pre-authorized charges, recurring payments, direct deposits, or bill payments.',
    },
    banner: {
      pin: {
        createPin: 'Create PIN',
      },
    },
    pin: {
      changePin: 'Change PIN',
      createPin: 'Create PIN',
    },
    pinAlert: {
      title: 'Set a PIN to use your card',
      info: 'Some merchants will require a PIN.',
    },
    expiredAlert: {
      title: 'Your card is expired',
      message: 'Start a chat and type ‘replace card’ to order a new one',
      button: 'Start chat',
    },
    suspendedAlert: {
      title: 'Card suspended',
      debitAlertInfo:
        'You won’t be able to use your Varo debit card while it’s in a suspended state.',
      believeAlertInfo:
        'You won’t be able to use your Varo Believe card while it’s in a suspended state.',
    },
    digitalCardAlert:
      'Your digital card is processing and will be available shortly. Check back later.',
    error: {
      title: 'Oops! Something went wrong.',
      message: 'Please try again later',
      button: 'Okay',
    },
    debitInfo:
      'Visa is registered trademark of Visa International Service Association. The Varo Visa® Debit Card is issued pursuant to a license from Visa U.S.A. Inc and may be used everywhere Visa debit cards are accepted.',
    believeInfo:
      'The Varo Believe Card is issued by Varo Bank pursuant to a license from Visa U.S.A. Inc and may be used everywhere Visa credit cards are accepted.',
    numberCopied: 'Card number copied',
    expiration: 'Exp',
    cvv: 'CVV',
    bottomSheet: {
      wallet: {
        headerTextLocked: 'Your card is locked',
        bodyTextLocked: 'Unlock your card to add it to your wallet.',
        headerTextFrozen: 'Your card is frozen',
        bodyTextFrozen: 'Unfreeze your card to add it to your wallet.',
      },
      buttons: {
        chatNow: 'Chat now',
        unlockCard: 'Unlock card',
        unfreezeCard: 'Unfreeze card',
      },
    },
  },
  newCardOnTheWay: {
    done: 'Done',
  },
  replaceCard: {
    reportLostStolen: 'Report lost or stolen card',
    headerTitle: 'Replace lost or stolen card',
    title: 'Tell us what happened',
    description: 'We’ll cancel your current card and send you a new one.',
    cardLost: 'My card is lost',
    cardStolen: 'My card was stolen',
    reviewDetails: 'Review details',
    errorTitle: 'Oops! Something went wrong.',
    errorMessage: 'Please try again later',
    done: 'Done',
    retry: 'Retry',
    sendNewCard: 'Send new card',
    goBack: 'Go back',
  },
  credentialChallenge: {
    confirmIdentity: {
      title: 'Confirm your identity',
      header: 'Confirm your identity',
      subtitle:
        "It's for your security. Let us know if you prefer an email or text.",
      SMS: 'Text message',
      EMAIL: 'Email',
      error: {
        title: 'Oops! Something went wrong.',
        message: 'Please try again later.',
        backButton: 'Back',
      },
    },
    otp: {
      emailHeader: 'We sent you an email',
      phoneHeader: 'We sent you a text',
      phoneDescription:
        'Enter the 6-digit code we sent to your phone number{{contactValue}}.',
      emailDescription:
        'Enter the 6-digit code we sent to your email{{contactValue}}.',
    },
    declined: {
      title: 'Unable to process your request',
      message:
        'Please refer to your physical card for the physical card and CVV.',
      doneButton: 'Done',
    },
  },
};
